<template>
  <p
    class="form-error-message-parts"
    v-if="showError && message"
    :class="{ 'form-error-message-parts--hidden': !showError }"
  >
    {{ message }}
  </p>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * エラーメッセージ表示
 */
export default defineComponent({
  name: 'FormErrorMessageParts',
  props: {
    /**
     * エラーを表示するかどうか
     */
    showError: {
      type: Boolean,
      default: false,
    },
    /**
     * 表示するメッセージ
     */
    message: {
      type: String,
      default: '',
    },
  },
})
</script>

<style lang="scss" scoped>
.form-error-message-parts {
  display: inline-flex;
  padding: 2px 0;
  text-align: left;
  margin-top: 0.4em;
  color: $red;
  @include fontSetTextSmall();

  &--hidden {
    visibility: hidden;
  }
}
</style>
